import { FieldBase } from "./field-base.model";

export class SelectorWithSearchField extends FieldBase<string> {
  controlType = "selectorWithSearch";
}
